/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    fontSize,
    enterpriseCSS,
    unitBase,
    rowSpacing,
} from './variables';

export const form = (typography, palette) => ({
    addressButtonRemove: {
        display: 'flex',
    },

    giftListV2: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'inherit',
            borderBottom: `1px solid ${palette.cms?.lightGray || '#AFAFAF'}`,
        },
        '& .select-input': {
            border: 'inherit !important',
            borderBottom: `1px solid ${palette.cms?.lightGray || '#AFAFAF !important'}`,
        },
        '& .borderErrorColor': {
            borderColor: palette.cms?.lightGray || '#a1001a !important',
        },
        '& .text-field-input': {
            padding: '4px 8px !important',
        },
        '& $adressButtonContainer': {
            justifyContent: 'space-between',
            '& $buttonContainer': {
                width: '100%',
                justifyContent: 'flex-end',
            },
            '@media only screen and (max-width: 600.5px) ': {
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column-reverse',
                '& $buttonContainer': {
                    width: '100%',
                    gap: '12px',
                    justifyContent: 'center',
                    '& .cancelButton': {
                        minWidth: 'unset',
                    },
                },
            },

        },

    },
    error: {
        color: palette.cms?.red || '#ff0000',
    },
    errorContainer: {
        border: `1px solid ${ palette.cms?.red || '#ff0000 !important'}`,
    },
    addressContainer: {
        display: 'flex',
        padding: '15px 20px 13px 20px',
        alignItems: 'center',
        borderBottom: '1px solid rgba(213, 213, 213, 1)',
        '@media only screen and (max-width: 600.5px) ': {
            display: 'block',
        },
        '& path': {
            fill: 'rgba(213, 213, 213, 1)',
        },
        '& p': {
            width: '35%',
            lineHeight: '20px',
            fontWeight: 700,
            '@media only screen and (max-width: 600.5px) ': {
                width: '100%',
            },
        },
        '& >div': {
            width: '60%',
            lineHeight: '1.25rem',
            '@media only screen and (max-width: 600.5px) ': {
                width: '100%',
            },
        },
    },
    profileName: {
        margin: '0px',
    },
    inputContianer: {
        margin: '12px auto',
        width: '100%',
        position: 'relative',
        padding: '0px 10px 0px 0px',
        '& input': {
            width: '100%',
            padding: '8px',
        },
        '& svg': {
            position: 'absolute',
            right: '24px',
            top: '6px',
        },
    },
    selectedForm: {
        overflowY: 'scroll',
        maxHeight: '260px',
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: 'rgba(156, 156, 156, 1)',  // scroll bar color
        },
        '&::-webkit-scrollbar': {  /* Works on scrollbar for Chrome, Safari and Opera */
            height: '2px',
            width: '10px',
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-track': {
            borderRadius: '10px',
            backgroundColor: 'transparent',
        },
    },
    selectedAddress: {
        border: `1px solid ${palette.cms?.green || '#387154'}`,
    },
    buttonContainer: {
        display: 'flex',
        gap: '35px',
    },

    adressButtonContainer: {
        display: 'flex',
        gap: '35px',
        margin: '20px 0px 0px 0px',
        justifyContent: 'end',
        '@media only screen and (max-width: 600.5px) ': {
            justifyContent: 'center',
            gap: '10px',
        },
    },
    confirmButtonAddress: {
        '& $buttonContainer': {
            width: '100%',
            flexDirection: 'row-reverse',
            '@media only screen and (max-width: 600.5px) ': {
                flexDirection: 'column-reverse',
            },
        },
    },

    form: {
        // padding: rowSpacing,
        'padding-top': 0,
        '&.gift-list-pin-number': {
            margin: `${rowSpacing * 2}px auto`,
            padding: `0 ${rowSpacing * 2}px`,
            maxWidth: 500,
        },
        '&[disabled]': {
            position: 'relative',
            '&:before': {
                content: '""',
                position: 'absolute',
                width: '100%',
                height: '100%',
                display: 'block',
                zIndex: 1,
            },
            '& > *': {
                filter: 'grayscale(1)',
                opacity: '0.6',
            },
        },

        '& .select-wrapper': { 'margin-bottom': 0 },

        '& .text-field-wrapper': {
            'margin-top': unitBase * 2,
            'margin-bottom': unitBase * 2,
            '& .input-label': {
                'white-space': 'nowrap',
                overflow: 'hidden',
                '&.error': {
                    color: palette.error.main,
                    opacity: '0.7',
                },
            },
            '& .input-field': {
                fontSize: '1rem',
            },
        },
        '& .select-field-wrapper': {
            'margin-top': unitBase * 2,
            'margin-bottom': unitBase * 2,
        },
        '& .account-select-menu-item': {
            fontSize: '16px',
        },
        '& .input-adorment.start': {
            marginRight: 0,
            '& p': {
                color: palette.common?.black || '#000',
                marginBottom: 2,
                fontSize: '0.87em',
            },
        },
        '& .input-adorment.end': {
            display: 'inline-table',
            '& p': {
                'font-size': fontSize.small,
                opacity: '0.7',
                marginBottom: 0,
            },
            '& svg': {
                width: '1.5em',
            },
        },
        '& .input-password-width': {
            minWidth: '100px',
        },
        '& .form-helper-text': {
            'margin-top': '8px !important',
            'margin-bottom': '0 !important',
            'font-size': '12px',
        },
        '& .order-number-adornment .input-adorment.start': {
            'margin-right': 0,
            '& > p': {
                color: enterpriseCSS.palette.black,
                fontSize: fontSize.component,
                marginBottom: 0,
            },
        },
        '& .suggested-address-wrapper': {
            position: 'relative',
            width: '100%',
        },
        '& .street-address-column': {
            position: 'relative',
            width: '100%',
            minWidth: 0,
        },
        '& .suggested-address': {
            left: 0,
            right: 0,
            top: '-6px',
            width: '100%',
            maxWidth: '100%',
            maxHeight: rowSpacing * 25,
            outline: 'none',
            position: 'absolute',
            'overflow-y': 'scroll',
            'overflow-x': 'hidden',
            boxSizing: 'border-box',
            'border-bottom-left-radius': unitBase,
            'border-bottom-right-radius': unitBase,
            'background-color': '#fff',
            'z-index': 2,
            '-webkit-box-shadow':
                    '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
            '& > li': {
                padding: `${unitBase * 2}px`, // trying to fit 7 suggested addresses in the dropdown
                'margin-right': 0,
                overflow: 'hidden',
                'white-space': 'nowrap',
                fontSize: '14px',
                minHeight: rowSpacing * 3,
                width: '100%',
                boxSizing: 'border-box',
                borderBottom: '1px solid #f3dddd',
            },
            '& .loqate-suggestion-row': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                gap: unitBase * 2,
            },
            '& .loqate-suggestion-primary': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                minWidth: 0,
                flex: '1 1 auto',
            },
            '& .loqate-suggestion-meta': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                flex: '0 0 auto',
                color: '#0A6DC8',
                gap: unitBase,
                textAlign: 'right',
            },
            '& .loqate-suggestion-count': {
                color: '#0A6DC8',
                fontWeight: 400,
            },
            '& .loqate-suggestion-chevron': {
                color: '#0A6DC8',
                fontSize: '1.8rem',
            },
        },
        '& input[disabled]': {
            color: enterpriseCSS.palette.gray1,
            border: `1px solid ${palette.disableButton}`,
            'background-color': enterpriseCSS.palette.gray3,
        },
        '& .address-added': {
            color: 'red',
            padding: '10px 0',
        },
        '& .locationType': {
            display: 'none',
        },
    },
});
